{
  "Accessibility Menu": "Menú de accesibilidad",
  "Reset settings": "Restablecer configuración",
  "Close": "Cerrar",
  "Content Adjustments": "Ajustes de contenido",
  "Adjust Font Size": "Ajustar el tamaño de fuente",
  "Highlight Title": "Destacar título",
  "Highlight Links": "Destacar enlaces",
  "Readable Font": "Fuente legible",
  "Color Adjustments": "Ajustes de color",
  "Dark Contrast": "Contraste oscuro",
  "Light Contrast": "Contraste claro",
  "High Contrast": "Alto contraste",
  "High Saturation": "Alta saturación",
  "Low Saturation": "Baja saturación",
  "Monochrome": "Monocromo",
  "Contrast": "Contraste",
  "Invert Colors": "Invertir colores",
  "Tools": "Herramientas",
  "Reading Guide": "Guía de lectura",
  "Stop Animations": "Detener animaciones",
  "Big Cursor": "Cursor grande",
  "Increase Font Size": "Aumentar tamaño de fuente",
  "Decrease Font Size": "Reducir tamaño de fuente",
  "Letter Spacing": "Espaciado entre letras",
  "Line Height": "Altura de línea",
  "Font Weight": "Grosor de fuente",
  "Dyslexia Font": "Fuente para dislexia",
  "Language": "Idioma",
  "Open Accessibility Menu": "Abrir menú de accesibilidad",
  "Widget Settings": "Configuración del widget",
  "Widget Position": "Posición del widget",
  "Top Left": "Arriba a la izquierda",
  "Top Center": "Arriba al centro",
  "Top Right": "Arriba a la derecha",
  "Center Left": "Centro a la izquierda",
  "Center Right": "Centro a la derecha",
  "Bottom Left": "Abajo a la izquierda",
  "Bottom Center": "Abajo al centro",
  "Bottom Right": "Abajo a la derecha",
  "Screen Reader": "Lector de pantalla",
  "Voice Navigation": "Navegación por voz",
  "Custom Color": "Color personalizado",
  "Change the site's colors": "Cambiar los colores del sitio",
  "Backgrounds": "Fondos",
  "Headings": "Encabezados",
  "Contents": "Contenidos",
  "Reset colors": "Restablecer colores",
  "Image Desaturation": "Desaturación de imagen",
  "Search languages": "Buscar idiomas",
  "No languages found": "No se encontraron idiomas",
  "Accessibility Profiles": "Perfiles de accesibilidad",
  "Motor Impaired": "Discapacidad motora",
  "Big cursor, voice navigation, and no animations.": "Cursor grande, navegación por voz y sin animaciones.",
  "Blind": "Ceguera",
  "Screen reader helpers with higher contrast.": "Asistentes de lector de pantalla con mayor contraste.",
  "Color Blind": "Daltonismo",
  "High contrast palette with desaturated media.": "Paleta de alto contraste con medios desaturados.",
  "Dyslexia": "Dislexia",
  "Friendly font, extra spacing, stronger weight.": "Tipografía amigable, más espaciado y mayor grosor.",
  "Low vision": "Baja visión",
  "Dark contrast and 130% magnification.": "Contraste oscuro y aumento del 130 %.",
  "Cognitive & Learning": "Cognitivo y aprendizaje",
  "Highlights key sections and enables voice help.": "Resalta secciones clave y habilita la ayuda por voz.",
  "Seizure & Epileptic": "Convulsiones y epilepsia",
  "Stops animations and desaturates imagery.": "Detiene las animaciones y desatura las imágenes.",
  "ADHD": "TDAH",
  "Reading guide, highlighted links, calmer palette.": "Guía de lectura, enlaces destacados y paleta más calmada.",
  "Widget Size": "Tamaño del widget",
  "Default": "Predeterminado",
  "Medium": "Mediano",
  "Small": "Pequeño",
  "Color Blindness": "Daltonismo",
  "Protanopia": "Protanopía",
  "Deuteranopia": "Deuteranopía",
  "Tritanopia": "Tritanopía",
  "Achromatopsia": "Acromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simula y asiste a usuarios con deficiencias en la visión del color."
}
